import { ls } from '@/plugins/vue-ls.ts';

export const updateLocalStorage = (newContext: {
    accountId?: number;
    userId?: number;
    divisionId?: number;
    leadId?: number;
    teamId?: number;
    groupId?: number;
}) => {
    if (ls) {
        const context = ls.get('context', {});

        ls.set('context', { ...context, ...newContext });
    }
};
